import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Divider,
  Icon,
} from 'antd';
import { Link } from 'react-router-dom';

import moment from 'moment';
import {
  createColumns,
  formatCell,
  sorter,
} from '../../../helpers';

import { Filters } from '../../../containers/Filters';
import DataTable from '../../../containers/DataTable';
import Graph from '../../Graph';
import Panes from '../../Panes';
import {
  Spinner,
  TooltippedLink,
} from '../../UI';

const { Title } = Typography;

class Country extends PureComponent {
  state = {
    filters: {
      dt1: '',
      dt2: '',
      aff: '',
      saff: '',
      timeZone: '',
      count: 10,
    },
    sevenDaysAgo: moment().subtract(7, 'd').format('YYYY-MM-DD'),
    today: moment(new Date()).format('YYYY-MM-DD'),
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      const payload = {
        dt1: this.state.sevenDaysAgo,
        dt2: this.state.today,
        aff: '',
        saff: '',
        timeZone: this.props.user.time_zone,
        count: this.state.filters.count,
      };

      this.setState((state) => {
        return {
          filters: {
            ...state.filters,
            dt1: payload.dt1,
            dt2: payload.dt2,
            timeZone: payload.timeZone,
          }
        };
      });

      this.props.fetchGeoStats(payload);
    });
  };

  handleChange = (date, dateString) => {
    const [dt1, dt2] = dateString;

    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          dt1,
          dt2,
        }
      };
    });

    const payload = {
      ...this.state.filters,
      dt1,
      dt2,
    };

    if (this.state.filters.aff) {
      this.props.fetchSaffList(payload);
    }

    this.handleChangeFilter(payload);
  };

  handleSelect = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          aff: value,
          saff: !!value ? state.filters.saff : '',
        }
      };
    });

    const payload = {
      ...this.state.filters,
      aff: value,
      saff: !!value ? this.state.filters.saff : '',
    };

    if (value) {
      this.props.fetchSaffList(payload);
    }

    this.handleChangeFilter(payload);
  };

  handleSaff = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          saff: value
        }
      };
    });

    const payload = {
      ...this.state.filters,
      saff: value,
    };

    this.handleChangeFilter(payload);
  };

  handleSub = (value) => {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          count: value
        }
      };
    });

    const payload = {
      ...this.state.filters,
      count: value
    };

    this.props.fetchGeoStats(payload);

    this.props.setFilter({
      ...this.props.filters,
      ...payload,
    });
  };

  handleChangeFilter = (payload) => {
    this.props.history.push({ search: '' });
    this.props.setFilter({
      ...this.props.filters,
      ...payload,
    });
    this.props.fetchGeoStats(payload);
  };

  update = () => {
    this.props.fetchGeoStats(this.state.filters);
  };

  render() {
    const {
      pageLoading,
      loading,
      geoStats,
      geoStats: {
        fields,
        data,
        tableName,
      }
    } = this.props;
    const fieldsObj = fields && fields[0];

    const renderTableCell = (text, record, item) => {
      if (item.html) {
        if (item.html.id === 'ErrClicksStats') {
          const to = `/reports/filtered_clicks?dt1=${this.state.filters.dt1}&dt2=${this.state.filters.dt2}&aff=${this.state.filters.aff}&saff=${this.state.filters.saff}`;

          return item.html.tooltip ? (
            <TooltippedLink
              title={item.html.tooltip}
              link={formatCell(item, text)}
              to={to}
            />
          ) : (
            <Link to={to}>{formatCell(item, text)}</Link>
          );
        }
      }

      return formatCell(item, text);
    };

    const columns = createColumns(
      fieldsObj,
      sorter,
      renderTableCell,
      this.getColumnSearchProps,
    );

    const graphOptions = [
      {
        tab: <span><Icon type="dollar"/>Money</span>,
        key: 'money',
        child: <Graph
          data={data}
          bars={[
            {
              fill: '#2196f3',
              dataKey: 'estAmount',
              name: 'Estimated Money',
              tooltipOptions: [
                {id: 1, shortName: 'verPerc', name: 'Verified Percent', suffix: '%'},
              ]
            },
            {
              fill: '#ff9800',
              dataKey: 'verAmount',
              name: 'Verified Money',
            },
          ]}
          XAxisDataKey="country"
        />
      },
      {
        tab: <span><Icon type="control" />Clicks</span>,
        key: 'clicks',
        child: <Graph
          data={data}
          bars={[
            {
              fill: '#2196f3',
              dataKey: 'estClicks',
              name: 'Estimated Clicks',
              tooltipOptions: [
                { id: 1, shortName: 'verPerc', name: 'Verified Percent', suffix: '%' },
              ]
            },
            {
              fill: '#ff9800',
              dataKey: 'verClicks',
              name: 'Verified Clicks',
            },
          ]}
          XAxisDataKey="country"
        />
      },
      {
        tab: <span><Icon type="project" />Requests</span>,
        key: 'requests',
        child: <Graph
          data={data}
          bars={[
            {
              fill: '#2196f3',
              dataKey: 'ReqCount',
              name: 'Total',
              tooltipOptions: [
                { id: 1, shortName: 'ReqCov', name: 'Coverage Percent', suffix: '%' },
              ]
            },
            {
              fill: '#ff9800',
              dataKey: 'ReqOkCount',
              name: 'Non-empty',
            },
          ]}
          XAxisDataKey="country"
        />
      },
    ];

    let content = <Spinner />;
    if (!pageLoading) {
      content = (
        <>
          <Divider />
          <Filters
            defaultDate={[
              moment().subtract(7, 'd'), moment()
            ]}
            handleChange={this.handleChange}
            handleSelect={this.handleSelect}
            handleSaff={this.handleSaff}
            handleSub={this.handleSub}
            topsLabel="Top Countries"
          />
          <Panes
            type="card"
            items={graphOptions}
            loading={loading}
            handleTab={this.handleTab}
          />
          <DataTable
            loading={loading}
            table={{
              columns: columns,
              data: geoStats,
              tableName: tableName,
              toolbar: {
                titleExport: 'Country Export',
              }
            }}
            update={this.update}
          />
        </>
      );
    }

    return (
      <div>
        <Title>Country</Title>
        {content}
      </div>
    );
  }
}

Country.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  geoStats: PropTypes.object.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  fetchGeoStats: PropTypes.func.isRequired,
  fetchSaffList: PropTypes.func.isRequired,
};

export default Country;
